<template>
  <div class="btn-group" role="group" :aria-label="ariaLabel">
    <template v-for="(option, _index) in options" :key="_index">
      <input
        :id="`${id}-${option}`"
        v-model="model"
        :name="`${id}-${option}`"
        :value="option"
        class="btn-check"
        autocomplete="off"
        :checked="option === model"
        type="radio"
      />
      <label class="btn btn-outline-primary" :for="`${id}-${option}`">{{
        translate(option)
      }}</label>
    </template>
  </div>
</template>
<script lang="ts" setup>
import {useLocalisation} from '@/composables/useLocalisation';

const {translate} = useLocalisation();

interface Props {
  id: string | number;
  ariaLabel?: string;
  modelValue: string;
  options: string[];
}

const props = withDefaults(defineProps<Props>(), {
  ariaLabel: 'Radio toggle button group',
});

const emit = defineEmits<{'update:modelValue': [value: string]}>();

const model = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value),
});
</script>
